// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1z-2";
export var placeholderIcon = "_1z-3";
export var thumbnailCanvas = "_1z-1";
export var thumbnailWrapper = "_1z-0";